import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useAllProjectsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.AllProjectsPageQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runAllProjectsPageQueryV1: result.run,
		modelAllProjectsPageQueryV1: result.model,
	}
}

export function useFinishedProjectsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.FinishedProjectsPageQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runFinishedProjectsPageQueryV1: result.run,
		modelFinishedProjectsPageQueryV1: result.model,
	}
}

export function useLinkeableTchProjectsByWorkspaceIdQueryV1(workspaceId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const result = {
		workspaceId: _workspaceId,
		...useQuery(() => new q.LinkeableTchProjectsByWorkspaceIdQueryV1(_workspaceId.value))
	}
	return {
		...result,
		runLinkeableTchProjectsByWorkspaceIdQueryV1: result.run,
		modelLinkeableTchProjectsByWorkspaceIdQueryV1: result.model,
	}
}

export function usePnlPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, viewDefId?: string | Ref<string>, pnlId?: string | null | Ref<string | null>, applyBenefitsConfidenceFactor?: boolean | Ref<boolean>, denomination?: any | Ref<any>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _viewDefId = isRef<string>(viewDefId) ? viewDefId : ref<string>(viewDefId)
	const _pnlId = isRef<string | null>(pnlId) ? pnlId : ref<string | null>(pnlId)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>(applyBenefitsConfidenceFactor)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		viewDefId: _viewDefId,
		pnlId: _pnlId,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		denomination: _denomination,
		...useQuery(() => new q.PnlPageQueryV1(_workspaceId.value, _tchProjectId.value, _viewDefId.value, _pnlId.value, _applyBenefitsConfidenceFactor.value, _denomination.value))
	}
	return {
		...result,
		runPnlPageQueryV1: result.run,
		modelPnlPageQueryV1: result.model,
	}
}

export function usePortfolioPlanningModuleStatusQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.PortfolioPlanningModuleStatusQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runPortfolioPlanningModuleStatusQueryV1: result.run,
		modelPortfolioPlanningModuleStatusQueryV1: result.model,
	}
}

export function usePortfolioSettingsQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.PortfolioSettingsQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runPortfolioSettingsQueryV1: result.run,
		modelPortfolioSettingsQueryV1: result.model,
	}
}

export function usePortfoliosPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.PortfoliosPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runPortfoliosPageQueryV1: result.run,
		modelPortfoliosPageQueryV1: result.model,
	}
}

export function useProposedProjectsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.ProposedProjectsPageQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runProposedProjectsPageQueryV1: result.run,
		modelProposedProjectsPageQueryV1: result.model,
	}
}

export function useScheduledProjectsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.ScheduledProjectsPageQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runScheduledProjectsPageQueryV1: result.run,
		modelScheduledProjectsPageQueryV1: result.model,
	}
}

export function useSpreadsheetImportMappingQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, blobId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _blobId = isRef<string>(blobId) ? blobId : ref<string>(blobId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		blobId: _blobId,
		...useQuery(() => new q.SpreadsheetImportMappingQueryV1(_workspaceId.value, _tchProjectId.value, _blobId.value))
	}
	return {
		...result,
		runSpreadsheetImportMappingQueryV1: result.run,
		modelSpreadsheetImportMappingQueryV1: result.model,
	}
}

export function useStartedProjectsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.StartedProjectsPageQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runStartedProjectsPageQueryV1: result.run,
		modelStartedProjectsPageQueryV1: result.model,
	}
}

